import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';


  export default class ParametersCurrencies extends Component{ 

    constructor(props){
      super(props);

      this.state={
          currencies:[],
          modalTitle:"",
          devise:"",
          currencyid:0,
          symbol:"",
          devisename:"",
          usrate:"",
          eurrate:"",
          

          CurrencyIdFilter:"",
          DeviseFilter:"",
          currenciesWithoutFilter:[],
          devises:[],
          deviseNames:[],
          deviseExists: false,
          deviseNameExists: false,
          loading: true,
          uniqueCurrencyIdsProducts:[],
          uniqueCurrencyIdsCostGrid:[],
        
      }
  }

  FilterFn(){
    var CurrencyIdFilter=this.state.CurrencyIdFilter;
    var DeviseFilter = this.state.DeviseFilter;

    var filteredData=this.state.currenciesWithoutFilter.filter(
        function(el){
            return el.currencyid.toString().toLowerCase().includes(
                CurrencyIdFilter.toString().trim().toLowerCase()
            )&&
            el.devise.toString().toLowerCase().includes(
                DeviseFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({currencies:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.currenciesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({currencies:sortedData});

}

changeCurrencyIdFilter = (e)=>{
  this.state.CurrencyIdFilter=e.target.value;
  this.FilterFn();
}
changeDeviseFilter = (e)=>{
  this.state.DeviseFilter=e.target.value;
  this.FilterFn();
}



refreshList = () => {
  axiosService.get('/currencies/')
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ currencies: data, currenciesWithoutFilter: data, loading: false });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};

fetchDevises() {
  axiosService.get('/currencies/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const devises = data.map(item => item.devise);
      this.setState({ devises: devises });
    })
    .catch(error => {
      console.error("Error fetching devises:", error);
    });
}

fetchDeviseNames() {
  axiosService.get('/currencies/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const deviseNames = data.map(item => item.devisename);
      this.setState({ deviseNames: deviseNames });
    })
    .catch(error => {
      console.error("Error fetching devise Names:", error);
    });
}

checkDeviseExists = (event) => {
  const enteredDevise = event.target.value.toLowerCase(); // Convert to lowercase
  const { devises } = this.state;
  const deviseExists = devises.some((devise) => devise.toLowerCase() === enteredDevise);
  this.setState({ deviseExists });
};



checkDeviseNameExists = (event) => {
  const enteredDeviseName = event.target.value.toLowerCase(); // Convert to lowercase
  const { deviseNames } = this.state;
  const deviseNameExists = deviseNames.some((deviseName) => deviseName.toLowerCase() === enteredDeviseName);
  this.setState({ deviseNameExists });
};


fetchCurrencyIdsProducts() {
  axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCurrencyIdsProducts = [...new Set(data.map((item) => item.currencyid))];
      this.setState({ uniqueCurrencyIdsProducts: uniqueCurrencyIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching Products data:', error);
    });
}

fetchCurrencyIdsCostGrid() {
  axiosService.get('/costgridcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueCurrencyIdsCostGrid = [...new Set(data.map((item) => item.currencyid))];
      this.setState({ uniqueCurrencyIdsCostGrid: uniqueCurrencyIdsCostGrid });
    })
    .catch((error) => {
      console.error('Error fetching CostGrid data:', error);
    });
}




componentDidMount(){
  this.refreshList();
  this.fetchDeviseNames();
  this.fetchDevises();
  this.fetchCurrencyIdsProducts();
  this.fetchCurrencyIdsCostGrid();
}

changeDevise =(e)=>{
  this.setState({devise:e.target.value});
}

changeSymbol =(e)=>{
  this.setState({symbol:e.target.value});
}


changeDeviseName =(e)=>{
  this.setState({devisename:e.target.value});
}

changeUsRate =(e)=>{
  this.setState({usrate:e.target.value});
}

changeEurRate =(e)=>{
  this.setState({eurrate:e.target.value});
}


addClick(){
  this.setState({
      modalTitle:"Add Currency",
      currencyid:0,
      devise: "",
      symbol: "",
      devisename: "",
      usrate:"",
      eurrate:"",
      deviseExists: false,
      deviseNameExists: false
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit Currency",
      currencyid:dep.currencyid,
      devise:dep.devise,
      symbol:dep.symbol,
      devisename:dep.devisename,
      usrate:dep.usrate,
      eurrate:dep.eurrate,
      initialDevise: dep.devise,
      initialSymbol: dep.symbol,
      initialDevisename: dep.devisename,
      initialUsrate:  dep.usrate,
      initialEurrate: dep.eurrate,
      deviseExists: false,
      deviseNameExists: false
  });
}

createClick() {
  const { devise, symbol, devisename, usrate, eurrate, devises, deviseNames } = this.state;

  if (!devise) {
    alert('Devise is required');
    return;
  }

  if (devises.some(item => item.toLowerCase() === devise.toLowerCase())) {
    alert('Devise already exists. Please provide a unique Devise.');
    return;
  }
  

  if (!devisename) {
    alert('Devise Name is required');
    return;
  }
  if (deviseNames.some(name => name.toLowerCase() === devisename.toLowerCase())) {
  alert('Devise Name already exists. Please provide a unique Devise Name.');
  return;
}


  if (!usrate) {
    alert('Usrate is required');
    return;
  }

  if (!eurrate) {
    alert('Eurrate is required');
    return;
  }

  axiosService.post('/currencies/', {
    devise: devise,
    symbol: symbol,
    devisename:devisename,
    usrate: usrate,
    eurrate: eurrate
  })
    .then(result => {
      alert('Currency created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {

  const { devise, symbol, devisename, usrate, eurrate, initialDevise, initialSymbol, initialDevisename, initialUsrate, initialEurrate, devises,deviseNames } = this.state;

   // Check if any changes are detected
   if (
    devise === initialDevise &&
    symbol === initialSymbol &&
    devisename === initialDevisename &&
    usrate === initialUsrate &&
    eurrate === initialEurrate
  ) {
    alert('No changes detected');
    return;
  }

  if (
    devises.some((existingDevise) => existingDevise.toLowerCase() === devise.toLowerCase() && devise !== initialDevise
    )
  ) {
    this.setState({ devise : initialDevise });
    return;
  }
  

  if (
    deviseNames.some((existingDeviseName) => existingDeviseName.toLowerCase() === devisename.toLowerCase() && devisename !== initialDevisename
    )
  ) {
    this.setState({ devisename : initialDevisename });
    return;
  }

  if (!devise) {
    alert('Devise is required');
    return;
  }

  if (!devisename) {
    alert('Devise Name is required');
    return;
  }

  if (!usrate) {
    alert('Usrate is required');
    return;
  }

  if (!eurrate) {
    alert('Eurrate is required');
    return;
  }
  

  axiosService.patch('/currencies/' + id + '/', {
    currencyid: this.state.currencyid,
    devise:this.state.devise,
    symbol: this.state.symbol,
    devisename: this.state.devisename,
    usrate: this.state.usrate,
    eurrate: this.state.eurrate

  })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert('Failed');
    });
}


deleteClick(id) {

  if (this.state.uniqueCurrencyIdsCostGrid.includes(id)) {
    alert('Cannot delete this Currency as it is in the CostGrid Table !');
    return; // Exit the function without making the delete request
  }

  if (window.confirm('Are you sure?')) {
    axiosService.delete('/currencies/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      currencies,
      modalTitle,
      currencyid,
      devise,
      symbol,
      devisename,
      usrate,
      eurrate,
      deviseExists,
      deviseNameExists,
      loading
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsParameters />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Currency
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      onChange={this.changeCurrencyIdFilter}
      style={{ width: "70px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>
  

      </div>
      CurrencyId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
      onChange={this.changeDeviseFilter}
      style={{ width: "100px", height:"30px" ,fontSize: "12px"}}
      placeholder="Filter"/>

      </div>
      Devise
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Symbol
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      DeviseName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Usrate
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Eurrate
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {currencies.map(dep=>
      <tr key={dep.currencyid} className="row-hover">
          <td className="table-text">{dep.currencyid}</td>
          <td className="table-text">{dep.devise}</td>
          <td className="table-text">{dep.symbol}</td>
          <td className="table-text">{dep.devisename}</td>
          <td className="table-text">{dep.usrate ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 10 }).format(dep.usrate) : 'N/A'}</td>
<td className="table-text">{dep.eurrate ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 10 }).format(dep.eurrate) : 'N/A'}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.currencyid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </div>

          </td>
          
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
      <span className="input-group-text" style={{ fontSize: "12px" }}>Devise</span>
          <input
            type="text"
            className={`form-control ${deviseExists ? "is-invalid" : ""}`}
            value={devise}
            onChange={this.changeDevise}
            onBlur={this.checkDeviseExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
          />
          {deviseExists && <div className="invalid-feedback">Devise already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Symbol</span>
          <input
            type="text"
            className="form-control"
            value={symbol}
            onChange={this.changeSymbol}
            style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
      <span className="input-group-text" style={{ fontSize: "12px" }}>Devise Name</span>
          <input
            type="text"
            className={`form-control ${deviseNameExists ? "is-invalid" : ""}`}
            value={devisename}
            onChange={this.changeDeviseName}
            onBlur={this.checkDeviseNameExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
          />
          {deviseNameExists && <div className="invalid-feedback" style={{ fontSize: "12px" }}>Devise Name already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Usrate</span>
          <input
            type="text"
            className="form-control"
            value={usrate}
            onChange={this.changeUsRate}
            style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Eurrate</span>
          <input
            type="text"
            className="form-control"
            value={eurrate}
            onChange={this.changeEurRate}
            style={{ fontSize: "12px" }}
          />
        </div>
        

        {currencyid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {currencyid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(currencyid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
}

